module.exports = __webpack_public_path__ + "static/media/inno.13fd0997.ico";